module.exports = __webpack_public_path__ + "static/img/net.ea23c2d2.png";